import { GA4UnifiedHelper } from '@ciaopeople/cp-shatsu/Stats';
import { GA4InitConfig } from '../../../config/GA4InitConfig.js';
import { MediaInfoRawData } from '../../../model/MediaInfo.js';
import { ProgressPercentage, SkipDirection } from '../StatsCommons.js';
import { TimeStatsCollectorAbstractBase } from './TimeStatsCollector.js';
import { MapperConfigFlags } from '../mappers/CommonEventMapper.js';


export interface GA4MapperConfig extends GA4InitConfig, MapperConfigFlags {
    
}
export interface GA4BasicCollectorConfig extends GA4InitConfig {
    eventNamespace: string
}

export type GABoolean = "true" | "false"

export type GA4EventParameters = {[k:string]: string|number};

export interface GA4CPMediaProperties {
    playlist_id?: string
    skip_direction?: string
}

export abstract class GA4MediaBasicCollector<INFO extends MediaInfoRawData<any>> extends TimeStatsCollectorAbstractBase {
    
    protected ga4inst: GA4UnifiedHelper;
    protected configureCalled: boolean;
        
    constructor(protected readonly cfg: GA4BasicCollectorConfig,
                protected win: WindowProxy,
               ) {
                    
        super();
        
        this.ga4inst = new GA4UnifiedHelper(win,{
            accountId: cfg.accountId,
            preload: false,
            trackingOptions: {
                useCookieDomain: cfg.cookieDomain,
            },
            defer: true,
            applyUserId: true
            
        });


        if(this.cfg.forcePage) {
            this.ga4inst.setPage(this.cfg.forcePage.name,this.cfg.forcePage.path);
        }
        this.configureCalled = false;
        
    }

    protected get ga4(): GA4UnifiedHelper  {
        if(!this.configureCalled) {
            this.configureCalled = true;
            this.ga4inst.configure();
        }
        return this.ga4inst;
    }

    protected abstract mangleEventData(eventName: string,  inputData: GA4EventParameters,info?: INFO): GA4EventParameters;

    protected abstract basicMediaParameters(info: INFO): GA4CPMediaProperties 

    protected trackEvent(evtName: string, props?: GA4EventParameters, info?: INFO): Promise<void> {
        const namespacedName = this.cfg.eventNamespace + "_" + evtName;
        const uProps = {
            ...(props?props:{}),
            ...(info?this.basicMediaParameters(info):{})
        }
        return this.ga4.sendEvent(namespacedName,this.mangleEventData(evtName,uProps,info));
    }



    mediaImpression(info: INFO, props?: GA4EventParameters): Promise<void> {
        
        return this.trackEvent("impression", {...props} ,info);
    }

    mediaCompleted(info: INFO, props?: GA4EventParameters): Promise<void> {
         return this.trackEvent("completed", {...props},info);
        
    }

    mediaStarted(info: INFO, props?: GA4EventParameters): Promise<void> {
        return this.trackEvent("started",{...props},info);
    }

   abstract mediaProgress(info: INFO, progress: ProgressPercentage, props?: GA4EventParameters): Promise<void> 
        
    skipMedia(info: INFO, skipDirection: SkipDirection): Promise<void> {
        return this.trackEvent("skip", {
            skip_direction: skipDirection
        }, info);
    }


    collectTiming(context: string, timingName: string, timingValue: number): Promise<void> {
        return this.trackEvent(context, {
            timing_name: timingName,
            timing_value: Math.trunc(timingValue)
        });
    }

}